module.exports = __webpack_public_path__ + "img/Subtips.95799fab.svg";